export const DashboardPeriod = [
  { id: 0, label: "Today", value: "today" },
  { id: 1, label: "Yesterday", value: "yesterday" },
  { id: 2, label: "Last 7 Days", value: "last7" },
  { id: 3, label: "Last 28 Days", value: "last28" },
  { id: 4, label: "Last 90 Days", value: "last90" },
  { id: 5, label: "This Year", value: "thisYear" },
  { id: 6, label: "Custom", value: "custom" },
  { id: 7, label: "All Times", value: "allTimes" },
];

export const ThemeColorsSet1 = [
  "#A12CFF",
  "#00B2FF",
  "#0DD9A2",
  "#16C542",
  "#FC6E00",
  "#AC92EC",
  "#E51010",
];
export const ThemeColorsSet2 = [
  "#032B20",
  "#088261",
  "#0DD9A2",
  "#AFFAE6",
  "#ECFEF9",
  "#F5F6F8",
];

export const DetectWelcomeMessage = () => {
  const hour = new Date().getHours();
  let message = "";
  switch (hour) {
    case 5:
    case 6:
    case 7:
    case 8:
    case 9:
    case 10:
    case 11:
      message = "Good Morning";
      break;
    case 12:
    case 13:
    case 14:
    case 15:
    case 16:
      message = "Good Afternoon";
      break;
    case 17:
    case 18:
    case 19:
    case 20:
      message = "Good Evening";
      break;
    default:
      message = "Good Night";
      break;
  }
  return message;
};
